import { render, staticRenderFns } from "./PaymentCheck.vue?vue&type=template&id=fae9e6b4&scoped=true&"
import script from "./PaymentCheck.vue?vue&type=script&lang=js&"
export * from "./PaymentCheck.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCheck.vue?vue&type=style&index=0&id=fae9e6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae9e6b4",
  null
  
)

export default component.exports